import React from "react";
import { Loader2, Inbox } from "lucide-react";

export function Card({ children, className = "", ...rest }) {
  return (
    <div {...rest} className={`bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-6 ${className}`}>
      {children}
    </div>
  );
}

export function StatCard({ icon: Icon, label, value, tone = "petrol", testid }) {
  const tones = {
    petrol: "bg-[#E0EFEA] text-[#087A73]",
    yellow: "bg-[#FBF0D6] text-[#8a6400]",
    dark: "bg-[#102A2A]/5 text-[#102A2A]",
    red: "bg-[#F9E3E0] text-[#C0392B]",
  };
  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-[#D2E3DB] shadow-sm p-5 flex items-center gap-4">
      <span className={`h-12 w-12 rounded-xl flex items-center justify-center shrink-0 ${tones[tone]}`}><Icon className="h-6 w-6" /></span>
      <div className="min-w-0">
        <p className="text-2xl font-extrabold text-[#102A2A] leading-tight">{value}</p>
        <p className="text-sm text-[#5C6B68] truncate">{label}</p>
      </div>
    </div>
  );
}

export function LoadingBlock() {
  return <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-[#087A73]" /></div>;
}

export function EmptyState({ title, subtitle, action }) {
  return (
    <div className="bg-white rounded-2xl border border-dashed border-[#D2E3DB] p-12 text-center">
      <span className="h-14 w-14 rounded-2xl bg-[#EAF3EF] text-[#087A73] flex items-center justify-center mx-auto mb-4"><Inbox className="h-7 w-7" /></span>
      <h3 className="text-lg font-bold text-[#102A2A]">{title}</h3>
      {subtitle && <p className="text-sm text-[#5C6B68] mt-1 max-w-sm mx-auto">{subtitle}</p>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}

export function DemoTag() {
  return <span className="inline-block text-[10px] font-bold uppercase tracking-wide bg-[#FBF0D6] text-[#8a6400] rounded px-2 py-0.5">Dati demo</span>;
}
